<div class="step-preview">
  <div class="step-header">
    <div>
      <h3>Resumo de Faturamento</h3>
      <p class="step-subtitle">
        Pré-visualização das faturas que serão geradas a partir dos itens selecionados nas etapas anteriores.
        Quotas e descontos por cliente já foram aplicados — os valores abaixo refletem o que cada
        cliente vai receber em fatura.
      </p>
    </div>
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-refresh" label="Recarregar resumo"
      [disabled]="loading" (click)="load()"></button>
  </div>

  <div class="summary-cards" *ngIf="preview">
    <div class="summary-card primary">
      <div class="summary-card-header">
        <i class="pi pi-file"></i>
        <span class="summary-card-title">Total de faturas</span>
      </div>
      <div class="summary-card-value">{{ preview.totalInvoices }}</div>
    </div>

    <div class="summary-card primary">
      <div class="summary-card-header">
        <i class="pi pi-dollar"></i>
        <span class="summary-card-title">Valor total</span>
      </div>
      <div class="summary-card-value money">
        {{ preview.totalValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
      </div>
    </div>

    <div class="summary-card">
      <div class="summary-card-header">
        <i class="pi pi-chart-line"></i>
        <span class="summary-card-title">Ticket médio</span>
      </div>
      <div class="summary-card-value">
        {{ averageInvoice | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
      </div>
    </div>

    <div class="summary-card" *ngIf="largestInvoice">
      <div class="summary-card-header">
        <i class="pi pi-arrow-up"></i>
        <span class="summary-card-title">Maior fatura</span>
      </div>
      <div class="summary-card-value">
        {{ largestInvoice.totalValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
      </div>
      <div class="summary-card-meta">{{ largestInvoice.customerName }}</div>
    </div>
  </div>

  <div class="company-breakdown" *ngIf="preview && preview.byCompany && preview.byCompany.length > 1">
    <h4>Por empresa</h4>
    <div class="company-chips">
      <div class="company-chip" *ngFor="let c of preview.byCompany">
        <span class="company-label">
          {{ c.billingCompanyId ? 'Empresa #' + c.billingCompanyId : 'Empresa principal' }}
        </span>
        <span class="company-stats">
          {{ c.invoiceCount }} faturas · {{ c.totalValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && !hasInvoices" class="empty-state">
    <i class="pi pi-info-circle"></i>
    <h4>Nenhuma fatura prevista</h4>
    <p>
      Volte para as etapas anteriores e selecione pelo menos um item para gerar faturas.
    </p>
  </div>

  <div class="invoices-table" *ngIf="hasInvoices">
    <div class="invoices-table-header">
      <h4>Faturas previstas ({{ preview!.totalInvoices }})</h4>
      <button pButton type="button" class="easymarine link"
        [icon]="tableExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        [label]="tableExpanded ? 'Recolher lista' : 'Expandir lista'"
        (click)="tableExpanded = !tableExpanded"></button>
    </div>
    <p-table *ngIf="tableExpanded" [value]="preview!.invoices"
      [paginator]="preview!.invoices.length > 50"
      [rows]="50" [rowsPerPageOptions]="[50, 100, 200, 500]"
      styleClass="p-datatable-sm preview-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 40px"></th>
          <th>Cliente</th>
          <th style="width: 90px; text-align: right">Itens</th>
          <th style="width: 130px">Vencimento</th>
          <th style="width: 160px; text-align: right">Valor</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-invoice>
        <tr class="invoice-row" (click)="toggleInvoice(invoice)">
          <td>
            <i class="pi" [class.pi-chevron-down]="isExpanded(invoice)"
               [class.pi-chevron-right]="!isExpanded(invoice)"></i>
          </td>
          <td>
            <div class="cell-customer">
              <span class="customer-name">{{ invoice.customerName || ('#' + invoice.customerId) }}</span>
              <span class="company-tag" *ngIf="invoice.billingCompanyId">
                Empresa #{{ invoice.billingCompanyId }}
              </span>
            </div>
          </td>
          <td style="text-align: right">{{ invoice.itemCount }}</td>
          <td>{{ invoice.earliestDueDate | date:'dd/MM/yyyy':'':'pt-BR' }}</td>
          <td style="text-align: right" class="money">
            {{ invoice.totalValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </td>
        </tr>
        <tr *ngIf="isExpanded(invoice)" class="invoice-breakdown-row">
          <td colspan="5">
            <table class="breakdown-table">
              <thead>
                <tr>
                  <th style="width: 140px">Origem</th>
                  <th>Embarcação</th>
                  <th>Serviço</th>
                  <th style="width: 100px; text-align: right">Quota</th>
                  <th style="width: 130px">Vencimento</th>
                  <th style="width: 130px; text-align: right">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let line of invoice.items">
                  <td>{{ sourceLabel(line.sourceType) }}</td>
                  <td>{{ line.boatName || '—' }}</td>
                  <td>
                    <ng-container *ngIf="line.orderNumber">Pedido #{{ line.orderNumber }} · </ng-container>
                    {{ (line.productName | translate) || '—' }}
                  </td>
                  <td style="text-align: right">
                    {{ line.quota != null ? (line.quota | number:'1.0-0') + '%' : '—' }}
                  </td>
                  <td>{{ line.dueDate | date:'dd/MM/yyyy':'':'pt-BR' }}</td>
                  <td style="text-align: right" class="money">
                    {{ line.value | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="step-actions">
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-arrow-left" label="Anterior"
      [disabled]="loading" (click)="back.emit()"></button>
    <button pButton type="button" class="easymarine primary"
      icon="pi pi-arrow-right" iconPos="right" label="Próximo"
      [disabled]="loading || !hasInvoices" (click)="next.emit()"></button>
  </div>
</div>
